import type { EmbedCardStyle, ReferenceParams } from '@blocksuite/hive-model';
import type { Command } from '@blocksuite/std';

import { insertEmbedCard } from '../../common/insert-embed-card.js';

export type LinkableFlavour =
  | 'hive:bookmark'
  | 'hive:embed-linked-doc'
  | 'hive:embed-iframe'
  | 'hive:embed-figma'
  | 'hive:embed-github'
  | 'hive:embed-loom'
  | 'hive:embed-youtube';

export type InsertedLinkType = {
  flavour: LinkableFlavour;
} | null;

export const insertEmbedLinkedDocCommand: Command<
  {
    docId: string;
    params?: ReferenceParams;
  },
  { blockId: string }
> = (ctx, next) => {
  const { docId, params, std } = ctx;
  const flavour = 'hive:embed-linked-doc';
  const targetStyle: EmbedCardStyle = 'vertical';
  const props: Record<string, unknown> = { pageId: docId };
  if (params) props.params = params;
  const blockId = insertEmbedCard(std, { flavour, targetStyle, props });
  if (!blockId) return;
  next({ blockId });
};
